export { useCompatRouter } from './useCompatRouter';
export type { CompatRouter } from './useCompatRouter';
export { shouldDisableAppRouterPrefetch } from './prefetch';
